import { getAuth } from "firebase/auth";
import { initializeApp } from "firebase/app";

const firebaseConfig = process.env.REACT_APP_FIREBASE_CONFIG

const App = initializeApp(JSON.parse(firebaseConfig));
export const firebaseApp = App
export const auth = getAuth(App);
export default App;